import { useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { WORKSPACE_CREATION_STEPS } from '../../../constants/workspaces';
import BasicWorkspaceDetails from './workspace-creation-steps/basic-workspace-details';
import Toaster from '../../../components/Snackbar/Toaster';
import useAuth from '../../../context/AuthContext';
import useLoader from '../../../context/LoaderContext';
import WorkspaceCreationFooter from './workspace-creation-footer';
import WorkspaceCreationHeader from './workspace-creation-header';
import WorkspaceProfileDetails from './workspace-creation-steps/workspace-profile-details';
import WorkspaceProjectDetails from './workspace-creation-steps/workspace-project-details';
import WorkspaceURLHandle from './workspace-creation-steps/workspace-url-handle';

const WorkspaceCreationBodyProps = {
  step: PropTypes.symbol.isRequired,
  setToast: PropTypes.func.isRequired,
};

const WorkspaceCreationBody = (props) => {
  const { step, setToast } = props;
  switch (step) {
    case WORKSPACE_CREATION_STEPS.BASIC_DETAILS: return <BasicWorkspaceDetails />;
    case WORKSPACE_CREATION_STEPS.URL_HANDLE: return <WorkspaceURLHandle setToast={setToast} />;
    case WORKSPACE_CREATION_STEPS.PROFILE_DETAILS: return <WorkspaceProfileDetails />;
    case WORKSPACE_CREATION_STEPS.PROJECT_DETAILS: return <WorkspaceProjectDetails />;
    default: return <BasicWorkspaceDetails />;
  }
};

const WorkspaceCreation = () => {
  // init
  const { authUser } = useAuth();
  const { setIsLoading } = useLoader();

  // states
  const [workspaceCreationStep, setWorkspaceCreationStep] = useState(WORKSPACE_CREATION_STEPS.BASIC_DETAILS);
  const [toast, setToast] = useState({ open: false, message: '', autoHideDuration: 3000 });

  useLayoutEffect(() => {
    if (authUser) setIsLoading(false);
  }, [authUser]);

  const handleToastClose = () => {
    setToast((prevstate) => ({ ...prevstate, open: false }));
  };

  return (
    <section className="workspace-creation-container">
      <WorkspaceCreationHeader step={workspaceCreationStep} />
      <WorkspaceCreationBody step={workspaceCreationStep} setToast={setToast} />
      <WorkspaceCreationFooter step={workspaceCreationStep} setStep={setWorkspaceCreationStep} setToast={setToast} />
      <Toaster onClose={handleToastClose} {...toast} />
    </section>
  );
};

WorkspaceCreationBody.propTypes = WorkspaceCreationBodyProps;

export default WorkspaceCreation;
